import React from 'react'
import PropTypes from 'prop-types'
import { withRouter } from '@/checkout-instore-legacy/utils/withRouter'
import isEmpty from 'lodash/isEmpty'

import { ROUTES } from '@/checkout-instore-legacy/constants/RoutesConstants'
import { isClientComplete } from '@/checkout-instore-legacy/customer/utils'
import { shouldAskUserForAddress } from '@/checkout-instore-legacy/cart/utils'
import {
  goToPaymentEvent,
  logClickEvent,
} from '@/checkout-instore-legacy/utils/EventHelper'
import { getCheckInFlagsOnOrder } from '@/checkout-instore-legacy/utils/checkInUtils'
import { getTotalItems } from '@/checkout-instore-legacy/utils/orderFormUtils'
import { getInstoreConfig } from '@/checkout-instore-legacy/utils/configUtils'

import IdentificationSummaryContainer from '../containers/IdentificationSummaryContainer'
import CartSummaryCard from './CartSummaryCard'
import ShippingSummaryCard from './ShippingSummaryCard'
import PaymentSummaryCard from './PaymentSummaryCard'
import CartSummary from '../containers/CartSummaryContainer'

import { isShippingValid } from '@/checkout-instore-legacy/shipping/utils'

class DefaultSummary extends React.Component {
  onShippingClick = () => {
    logClickEvent('summary-shipping', 'Sale')
    const { orderForm } = this.props.order
    const shouldGoToShipping = shouldAskUserForAddress(orderForm)

    if (shouldGoToShipping) {
      const customer = orderForm.clientProfileData
      if (customer && isClientComplete(customer)) {
        this.props.router.push('/shipping-postalcode')
      } else if (customer && !isClientComplete(customer)) {
        this.props.router.push('/client-register')
      } else {
        this.props.router.push('/')
      }
    }
  }

  onCartClick = () => {
    logClickEvent('summary-cart', 'Sale')

    setTimeout(() => {
      this.props.router.push('/cart')
    }, 280)
  }

  onPaymentClick = () => {
    const { orderForm } = this.props.order
    const validShipping = isShippingValid(orderForm.shippingData)

    if (validShipping) {
      logClickEvent('summary-payment', 'Sale')
      goToPaymentEvent(orderForm)
      this.props.router.push('/payment')
    }
  }

  vendorCodeRequiredIsEmpty = () => {
    const { openTextField: vendorCodeField } = this.props.order.orderForm
    const { noteAsVendorCode } = getInstoreConfig()

    return (
      !isEmpty(noteAsVendorCode) &&
      (isEmpty(vendorCodeField) || isEmpty(vendorCodeField.value))
    )
  }

  render() {
    const {
      location: { pathname },
      order,
      waitingForGiftCardArrival,
      hasAtLeastOneValidItem,
      isOnline,
    } = this.props
    const orderForm = order.orderForm

    if (!orderForm) {
      return null
    }

    const itemQuantity = getTotalItems(orderForm)
    const vendorCodeRequiredIsEmpty = this.vendorCodeRequiredIsEmpty()

    const { isTakeAwayOnly } = getCheckInFlagsOnOrder(orderForm)
    return (
      <div className="flex flex-column justify-between flex-auto">
        <div>
          <IdentificationSummaryContainer
            active={
              pathname === ROUTES.HOME || pathname === ROUTES.CLIENT_PROFILE
            }
            clientProfileData={orderForm.clientProfileData}
            storePreferencesData={orderForm.storePreferencesData}
          />
          <div>
            <CartSummaryCard
              itemQuantity={itemQuantity}
              active={pathname.includes(ROUTES.CART)}
              handleCardClick={this.onCartClick}
              disabled={!isOnline}
            />
            {!isTakeAwayOnly && (
              <ShippingSummaryCard
                logisticInfo={
                  orderForm.shippingData
                    ? orderForm.shippingData.logisticsInfo
                    : []
                }
                active={pathname.includes('/shipping-')}
                handleCardClick={this.onShippingClick}
                hover={itemQuantity > 0 && !vendorCodeRequiredIsEmpty}
                disabled={!isOnline || vendorCodeRequiredIsEmpty}
              />
            )}
            <PaymentSummaryCard
              paymentSystems={orderForm.paymentData.paymentSystems}
              payments={orderForm.paymentData.payments}
              giftCards={orderForm.paymentData.giftCards.filter(
                (giftCard) => giftCard.inUse
              )}
              isTakeAwayOnly={isTakeAwayOnly}
              active={pathname === ROUTES.PAYMENT}
              handleCardClick={this.onPaymentClick}
              hover={
                !waitingForGiftCardArrival &&
                !vendorCodeRequiredIsEmpty &&
                (isTakeAwayOnly
                  ? itemQuantity > 0
                  : isShippingValid(orderForm.shippingData))
              }
              disabled={
                !isOnline ||
                waitingForGiftCardArrival ||
                vendorCodeRequiredIsEmpty
              }
            />
          </div>
        </div>
        <div>
          <div className="bb b--muted-4" />
          <CartSummary
            isTakeAwayOnly={isTakeAwayOnly}
            isValidCart={hasAtLeastOneValidItem}
          />
        </div>
      </div>
    )
  }
}

DefaultSummary.propTypes = {
  router: PropTypes.any,
  location: PropTypes.object.isRequired,
  order: PropTypes.object.isRequired,
  waitingForGiftCardArrival: PropTypes.bool,
  hasAtLeastOneValidItem: PropTypes.bool,
  isOnline: PropTypes.bool,
}

DefaultSummary.defaultProps = {
  isOnline: true,
}

export default withRouter(DefaultSummary)
